import * as React from 'react';
import {OptionDifferenceDto} from '../../services/Client';
import OptionDifferenceService from '../../services/OptionDifferenceService';
import {ITranslatedComponent} from '../../redux/reducers/generalReducer';
import {translate} from 'react-i18next';
import OptionDifferenceRow from './OptionDifferenceRow';
import {compose} from 'redux';

export interface MarketDiffValue {
    baseMarketValue: React.ReactNode;
    specificMarketValue: React.ReactNode;
}

export interface OptionDifferenceTableItem {
    key: string;
    label: string | undefined;
    labelRowSpan: number;
    diffValues: MarketDiffValue[];
}

interface IOptionDifferenceTableProps extends ITranslatedComponent {
    differences: OptionDifferenceDto;
    selectedKeys: string[];
}

const OptionDifferenceTable: React.StatelessComponent<IOptionDifferenceTableProps> = (props: IOptionDifferenceTableProps) => {

    const items: OptionDifferenceTableItem[] = OptionDifferenceService.buildItems(props.differences);
    const filteredItems: OptionDifferenceTableItem[] = items.filter((item: OptionDifferenceTableItem) =>
        props.selectedKeys.findIndex((key: any) => key === item.key) !== -1);

    return (
        <table className='option-difference-table'>
            <thead>
                <tr>
                    <th> <h3> <b> {props.t('PROPERTY_NAME')}  </b> </h3> </th>
                    <th> <h3> <b>  {props.t('BASIC_MARKET_VALUE')}  </b> </h3> </th>
                    <th> <h3> <b>  {props.t('SPECIFIC_MARKET_VALUE')}  </b> </h3> </th>
                </tr>
            </thead>

            <tbody>
                {filteredItems.map((item: OptionDifferenceTableItem, index: number) =>
                    <OptionDifferenceRow key={'option_difference_row_' + index} item={item} />)}
            </tbody>
        </table>
    );
};

export default compose<React.ComponentType<any>>(
    translate(["OPTIONS_VIEW", "COLUMN_FACTORY"]),
)(OptionDifferenceTable);



// WEBPACK FOOTER //
// ./src/views/OptionDifferenceView/OptionDifferenceTable.tsx